import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import VerwaltungTabLeiste from './VerwaltungTabLeiste';
import { useVerlaufMerken } from '../admin/ZurueckLink';
import { useTabellenKarten } from '../admin/tabellenKarten';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    return localStorage.getItem('sidebar-collapsed') === 'true';
  });
  const { pathname } = useLocation();
  const mainRef = useRef<HTMLElement>(null);

  // Für „Zurück zu …“ auf den Verwaltungsseiten (components/admin/ZurueckLink).
  useVerlaufMerken();
  // Tabellen werden auf dem Handy zu Karten; die Zellen brauchen dafür ihre Spaltennamen.
  useTabellenKarten(mainRef);

  // Ein Seitenwechsel schließt das Menü (auch über Links im Inhalt, nicht nur im Menü).
  useEffect(() => { setSidebarOpen(false); }, [pathname]);

  const handleCollapse = () => {
    const next = !sidebarCollapsed;
    setSidebarCollapsed(next);
    localStorage.setItem('sidebar-collapsed', String(next));
  };

  return (
    <div className={`layout ${sidebarCollapsed ? 'sidebar-is-collapsed' : ''}`}>
      <a href="#main-content" className="skip-link">
        Zum Inhalt springen
      </a>
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={sidebarCollapsed}
        onToggleCollapse={handleCollapse}
      />
      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
        {/* Keine Kopfleiste: jede Seite trägt ihren Titel selbst, die Seitenleiste nennt den
            Bereich. Auf dem Handy führt die Tab-Leiste unten, „Mehr" öffnet das ganze Menü. */}
        <main id="main-content" ref={mainRef} className="main-body" aria-label="Inhalt">
          {children}
        </main>
      </div>
      <VerwaltungTabLeiste mehrOffen={sidebarOpen} onMehr={() => setSidebarOpen(o => !o)} />
    </div>
  );
};

export default Layout;
